// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Send',
    stop: 'Stop',
    attach: 'Attach files',
    add: 'Add',
    upload_files: 'Upload files',
  },
  attachment: {
    uploading: 'Uploading {{percent}}%',
    uploading_file: 'Uploading {{name}}',
    retry: 'Retry',
    remove: 'Remove {{name}}',
    cancel: 'Cancel uploading {{name}}',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Waiting',
    running: 'Running',
    done: 'Done',
    failed: 'Failed',
    denied: 'Refused',
    background: 'Background',
    summary_one: '{{count}} step',
    summary_other: '{{count}} steps',
    failed_count_one: '{{count}} failed',
    failed_count_other: '{{count}} failed',
    retried_one: '{{count}} failed and was retried',
    retried_other: '{{count}} failed and were retried',
  },
  question: {
    suggested: 'Suggested',
    withdrawn: 'No longer needed',
  },
  thread: {
    live_on: 'Live on {{domain}}',
    unread_one: '{{count}} new',
    unread_other: '{{count}} new',
    working: 'Working on it',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Done',
    running: 'In progress',
    waiting: 'Needs attention',
    failed: 'Failed',
    pending: 'Not yet',
    skipped: 'Skipped',
  },
  lightbox: {
    enlarge: 'Enlarge: {{label}}',
    close: 'Close',
  },
};
